import { deserialize, deserializeArray, serialize } from 'class-transformer';
import { Guid } from 'guid-typescript';
import { MachineSoftwareUpdateState } from './MachineSoftwareUpdateState';
import { UserProceedWithUpdateResponse } from './UserProceedWithUpdateResponse';

export class UISWUpdateData {
  account_id: string;
  machine_id: string;
  machine_name: string;
  ui_version: string;
  user_proceed_with_update_response: UserProceedWithUpdateResponse;
  software_update_state: MachineSoftwareUpdateState;
  sent_utc: string;

  constructor() {
    this.account_id = Guid.EMPTY.toString();
    this.machine_id = Guid.EMPTY.toString();
    this.machine_name = '';
    this.ui_version = '';
    this.user_proceed_with_update_response = UserProceedWithUpdateResponse.UNKNOWN;
    this.software_update_state = MachineSoftwareUpdateState.UNKNOWN;
    this.sent_utc = new Date().toISOString();
  }

  static toModel(json: string): UISWUpdateData {
    const model = deserialize(UISWUpdateData, json);
    return model;
  }

  static toModelCollection(json: string): UISWUpdateData[] {
    const models = deserializeArray(UISWUpdateData, json);
    return models;
  }

  fromModelToJson(): string {
    const jsObj = serialize(this);
    return jsObj;
  }
}
